import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <section id="comprar" className="py-16 md:py-32 bg-dark-900 text-center" data-id="element-45">
      <div className="container mx-auto px-6 max-w-3xl" data-id="element-46">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-47">
          <h2 className="text-4xl md:text-6xl font-bold text-white mb-8 leading-tight" data-id="element-48">
            Si te importa de verdad la salud de tu mascota...
          </h2>
          <p className="text-2xl text-gray-400 mb-12 font-serif italic" data-id="element-49">
            "No puedes seguir delegando su alimentación en productos que no
            controlas."
          </p>

          <div className="mb-8" data-id="element-50">
            <div className="flex items-center justify-center gap-4 mb-2" data-id="element-51">
              <span className="text-3xl md:text-4xl text-gray-500 line-through" data-id="element-52">
                24,99€
              </span>
              <span className="text-6xl md:text-7xl font-bold text-earth-amber" data-id="element-53">
                12,99€
              </span>
            </div>
            <span className="inline-block bg-red-600 text-white text-sm font-bold py-1 px-3 rounded-md uppercase tracking-wide mb-3" data-id="element-54">
              Oferta -48%
            </span>
            <p className="text-gray-500 mt-2 text-lg" data-id="element-55">
              Pago único • Sin suscripciones
            </p>
          </div>

          <motion.a href="https://shop.beacons.ai/recetascaseras_/4b20cde5-cc33-4de9-a239-04641ec068be" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="inline-block bg-earth-amber hover:bg-earth-gold text-dark-900 font-bold text-xl py-5 px-10 rounded-xl shadow-[0_0_30px_rgba(232,184,74,0.3)] transition-all cursor-pointer" data-id="element-56">
            Obtener la Guía Ahora — 12,99€
          </motion.a>
          <p className="mt-6 text-sm text-gray-500" data-id="element-57">
            Acceso inmediato • Descarga digital • Pago seguro
          </p>
        </motion.div>
      </div>
    </section>;
}